import { speakingSessionStore } from 'store';
import { useSelector } from 'react-redux';
import { SpeakingSessionDto } from 'api/planning';
import { useNavigationContext, useTableStateChange } from 'hooks';

export const useSpeakingSessions = () => {
  const { locationId } = useNavigationContext();
  const tableState = useSelector(speakingSessionStore.selectors.tableState);

  const { data, isFetching, isLoading } = speakingSessionStore.service.useGetSpeakingSessionsQuery(
    {
      tableState,
      locationId: locationId!,
    },
    { skip: !locationId }
  );

  const onTableStateChange = useTableStateChange<SpeakingSessionDto>(
    speakingSessionStore.actions.updateTableState
  );

  return {
    speakingSessions: data,
    isFetching,
    isLoading,
    onTableStateChange,
    tableState,
  };
};
